import React from 'react';
import {useSelector} from 'react-redux';
import {SafeAreaView} from 'react-native-safe-area-context';
import {View, TouchableOpacity, Alert} from 'react-native';
import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';
import FastImage from '../../Utils/FastImage';
import {apiFlagPhotos} from 'src/Utils/apiCalls';

//////////////////////
///////// components

import {PrimaryButton, FooterOverlay} from 'src/Modules/CommonView';
import {setDataAtPath} from '../../Utils/fireUtils';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {FlatList} from 'react-native-gesture-handler';
import {PhotoTile} from '../../LandingPage/CommunityPhotos';

const Photos = ({
  flag,
  hideClose,
  handleBack,
  showFlag = 0,
  photoData = [],
  useEventPhotos = false,
  selectedGroupId = false,
  handleSelection,
  selectable,
  selection = [],
}) => {
  const {width} = useWindowDimensionsSafe();

  const backupPhotoData = [];

  const playerChallengePhotos = useSelector(
    (state) => state.game.playerChallengePhotos || {},
  );
  const treasureChallengePhotos = useSelector(
    (state) => state.game.treasureChallengePhotos || {},
  );

  //insulate from null challengePhotos
  if (playerChallengePhotos) {
    console.log({playerChallengePhotos});
    if (treasureChallengePhotos?.isArray?.()) {
      backupPhotoData?.push(...playerChallengePhotos);
    } else if (typeof treasureChallengePhotos == 'object') {
      backupPhotoData?.push(...Object.values(playerChallengePhotos || {}));
    }
  }

  if (treasureChallengePhotos) {
    console.log({treasureChallengePhotos});
    if (treasureChallengePhotos?.isArray?.()) {
      backupPhotoData?.push(...treasureChallengePhotos);
    } else if (typeof treasureChallengePhotos == 'object') {
      backupPhotoData?.push(...Object.values(treasureChallengePhotos || {}));
    }
  }

  var photoObjects = photoData || backupPhotoData;

  if (useEventPhotos) {
    const photoData = useSelector((state) => state.event?.photos || {});
    console.log({photoData});

    photoObjects = [];
    if (selectedGroupId) {
      photoObjects =
        photoData?.[selectedGroupId] &&
        Object.values(photoData[selectedGroupId].photos || {});
    } else {
      Object.values(photoData)?.map?.((group) => {
        if (group && group.photos) {
          photoObjects = [
            ...photoObjects,
            ...Object.values(group.photos || {}),
          ];
        }
      });
    }
  }

  return (
    <SafeAreaView style={{flex: 1, backgroundColor: 'white', display: 'flex'}}>
      {!!photoObjects?.length && !selectable && (
        <FlatList
          data={photoObjects}
          removeClippedSubviews
          keyExtractor={(item) => item.UUID}
          contentContainerStyle={{paddingBottom: 200}}
          renderItem={({item: photo, index}) => {
            // global.devAlert(item);
            const challengeText =
              photo.challengeText ||
              photo.challenge ||
              photo.question ||
              photo.task ||
              photo.description ||
              ' ';
            const photoUrl =
              photo.thumbnail ||
              photo.share_photo ||
              photo.photoURL ||
              photo.photoUrl ||
              photo.downloadURL ||
              (photo.completion ? photo.completion.photoUrl : null);

            const isVideo =
              photo.type === 'video' ||
              photo.type === 'Video' ||
              !!photo.thumbnail ||
              challengeText?.includes('Video') ||
              challengeText?.includes('Capture') ||
              challengeText?.includes('video') ||
              photoUrl?.includes('video');
            return (
              <PhotoTile
                handlePress={() => {
                  navigationRef.navigate('PhotoVideoCamera', {
                    text: challengeText,
                    photoUrl,
                    onReport: !showFlag
                      ? null
                      : () => {
                          if (flag) {
                            navigationRef.navigate('ConfirmModal', {
                              titleText: `Are you Positve You Want To Flag This Photo`,
                              confirmText: 'Yes, Flag for Removal!!!',
                              cancelText: 'Cancel',
                              handleConfirm: (handleDone) => {
                                console.log('onReport', {photo});
                                apiFlagPhotos({
                                  photoId: photo.id,
                                  photoUrl,
                                });
                                setDataAtPath(photo.path || 'error', null);
                                handleDone();
                                Alert.alert(
                                  'This Photo Was Flagged For Removal',
                                  'We apologize for any inappropriate content. Thank you for helping to keep our community clean. The photo will be gone when you fully close and reopen the app.',
                                );
                              },
                            });
                          } else {
                            navigationRef.navigate('QuestionFeedback', {
                              challenge: photo,
                              type: photo.type,
                            });
                          }
                        },
                    shareUUID: photo.shareUUID,
                    isVideo,
                  });
                }}
                photo={photo}
                index={index}
                descriptionOverride={photo?.challenge}
                descriptionStyle={{
                  color: global.color.white,
                  fontSize: 16,
                  paddingLeft: 5,
                  lineHeight: 22,
                  fontFamily: global.font.circularBold,
                  backgroundColor: 'black',
                }}
              />
            );
          }}
        />
      )}
      {!!selectable && (
        <View
          style={{
            flex: 1,
            flexDirection: 'row',
            flexWrap: 'wrap',
            marginTop: 5,
          }}>
          {photoObjects?.map?.((photo, index) => {
            var selected = false;
            if (selectable && selection?.includes?.(index)) {
              selected = true;
            }
            console.log({selection, index});
            // console.log('the download url is: ', photo.downloadURL);
            return (
              <TouchableOpacity
                key={`photos_view_${index}`}
                onPress={() => {
                  if (selectable) {
                    return handleSelection(index);
                  }
                  console.log({photo});
                  const challengeText =
                    photo.challengeText ||
                    photo.challenge ||
                    photo.question ||
                    photo.task ||
                    photo.description ||
                    ' ';
                  const photoUrl =
                    photo.photoURL ||
                    photo.photoUrl ||
                    photo.downloadURL ||
                    (photo.completion ? photo.completion.photoUrl : null);

                  const isVideo =
                    photo.type === 'video' ||
                    photo.type === 'Video' ||
                    !!photo.thumbnail ||
                    challengeText?.includes('Video') ||
                    challengeText?.includes('video') ||
                    photoUrl?.includes('video');
                  navigationRef.navigate('PhotoVideoCamera', {
                    text: challengeText,
                    photoUrl,
                    onReport: !showFlag
                      ? null
                      : () => {
                          if (flag) {
                            navigationRef.navigate('ConfirmModal', {
                              titleText: `Are you Sure You Want To Flag This Photo?`,
                              confirmText: 'Yes, Flag for Removal!!',
                              cancelText: 'Cancel',
                              handleConfirm: (handleDone) => {
                                console.log('onReport', {photo});
                                apiFlagPhotos({
                                  photoId: photo.id,
                                  photoUrl,
                                });
                                setDataAtPath(photo.path || 'error', null);
                                handleDone();
                                Alert.alert(
                                  'This Photo Was Flagged For Removal',
                                  'We apologize for any inappropriate content. Thank you for helping to keep our community clean. The photo will be gone when you fully close and reopen the app.',
                                );
                              },
                            });
                          } else {
                            navigationRef.navigate('QuestionFeedback', {
                              challenge: photo,
                              type: photo.type,
                            });
                          }
                        },
                    shareUUID: photo.shareUUID,
                    isVideo,
                  });
                }}>
                <FastImage
                  style={{
                    width: (width - 20) / 3,
                    height: (width - 20) / 3,
                    marginLeft: 3.33,
                    marginRight: 3.33,
                    marginBottom: 6.66,
                    backgroundColor: 'black',
                    borderWidth: selected ? 5 : 0,
                    borderColor: 'green',
                  }}
                  resizeMode={FastImage?.resizeMode?.cover}
                  //resizeMode={"cover"}
                  source={{
                    uri:
                      photo.thumbnail ||
                      photo.downloadURL ||
                      photo.photoUrl ||
                      photo.photoURL,
                  }}
                />
              </TouchableOpacity>
            );
          })}
          <View style={{height: 20, width: width}} />
        </View>
      )}

      {!hideClose && (
        <FooterOverlay>
          <PrimaryButton
            background={global?.color?.gray3}
            text={'Back'}
            handlePress={handleBack}
          />
        </FooterOverlay>
      )}
    </SafeAreaView>
  );
};

export default Photos;
